import _ from "lodash";

const validationTypeDeclaration = (selectedDeclarationType: string | null) => {
    const errors = {
        typeDeclaration: '',
    };

    if (_.isNil(selectedDeclarationType) || _.isEmpty(selectedDeclarationType)) {
        errors.typeDeclaration = 'Le type de déclaration est obligatoire pour continuer';
    }

    return _.pickBy(errors, (value) => value !== '');
}

export default validationTypeDeclaration;